var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.TrailerTrackingUsageNotice"),
        width: "450px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { width: "345px" } },
        [
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(_vm._s(_vm.$t("queryJob.TrailerTrackingUsageNotice")))
          ]),
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(
              _vm._s(_vm.$t("queryJob.N1SituationIncludingButDepartments"))
            )
          ]),
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(
              _vm._s(_vm.$t("queryJob.N2ConsentBeforeQueryingCommunication"))
            )
          ]),
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(_vm._s(_vm.$t("queryJob.N3TheOwnersConsentConsequences")))
          ]),
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(_vm._s(_vm.$t("queryJob.N4ItToIrrelevantUser")))
          ]),
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(
              _vm._s(_vm.$t("queryJob.N5SystemCannotGuaranteeResponsibility"))
            )
          ]),
          _c("span", { staticStyle: { display: "block" } }, [
            _vm._v(_vm._s(_vm.$t("queryJob.N6BeAwareOfHome")))
          ]),
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.notRemindNextTime,
                callback: function($$v) {
                  _vm.notRemindNextTime = $$v
                },
                expression: "notRemindNextTime"
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.DoNotRemindMeAgain")))]
          ),
          _c(
            "center",
            [
              _c("el-button", { on: { click: _vm.submitHandler } }, [
                _vm._v(
                  _vm._s(_vm.$t("queryJob.IUnderstoodAndConfirmContinuing"))
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }